<template>
  <div>
    <el-form :inline="true" :model="searchData" class="demo-form-inline">
      <el-form-item label="商戶號">
        <el-input v-model="searchData.customer_id" placeholder="請輸入商戶號">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="currentDate"
          type="datetimerange"
          start-placeholder="開始時間"
          end-placeholder="結束時間"
          :default-time="['00:00:00', '23:59:59']"
          :picker-options="{ disabledDate: $store.state.disabledDate }"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="
            page = 1;
            inSearch = true;
            saveData = false;
            getData();
          "
          >搜尋</el-button
        >
      </el-form-item>
    </el-form>
    <h2>一般代理數據列表</h2>
    <el-table
      :data="list"
      style="width: 100%;margin-bottom: 20px;"
      :span-method="arraySpanMethod"
      border
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <!-- :show-header="false" -->
          <el-table
            class="table-in-table"
            :data="props.row.children"
            style="width: 100%;"
            row-key="id"
            border
          >
            <el-table-column
              align="center"
              prop="date"
              rowspan="2"
              label="日期"
            >
            </el-table-column>
            <el-table-column align="center" prop="s_today" label="結餘">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.s_today | decimalPoint | thousands }}
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="s_yesterday" label="初始餘額">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.s_yesterday | decimalPoint | thousands }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="c_amount"
              label="代收成功金額"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.c_amount | decimalPoint | thousands }}
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="c_fee" label="代收手續費">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.c_fee | decimalPoint | thousands }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="m_add_amount"
              label="手動增加金額"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.m_add_amount | decimalPoint | thousands }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="m_reduce_amount"
              label="手動減少金額"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.m_reduce_amount | decimalPoint | thousands }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="unfreeze_amount"
              label="解凍金額"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.unfreeze_amount | decimalPoint | thousands }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="freeze_amount"
              label="凍結金額"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.freeze_amount | decimalPoint | thousands }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="id" label="商戶號">
      </el-table-column>
      <el-table-column align="center" prop="user_name" label="用戶名">
      </el-table-column>
      <el-table-column align="center" prop="s_today" label="結餘">
        <template slot-scope="scope">
          <div>
            {{ scope.row.s_today | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="s_yesterday" label="初始餘額">
        <template slot-scope="scope">
          <div>
            {{ scope.row.s_yesterday | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="c_amount" label="代收利潤">
        <template slot-scope="scope">
          <div>
            {{ scope.row.c_benefit | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="m_add_amount" label="手動增加金額">
        <template slot-scope="scope">
          <div>
            {{ scope.row.m_add_amount | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="m_reduce_amount"
        label="手動減少金額"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.m_reduce_amount | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="unfreeze_amount" label="解凍金額">
        <template slot-scope="scope">
          <div>
            {{ scope.row.unfreeze_amount | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="freeze_amount" label="凍結金額">
        <template slot-scope="scope">
          <div>
            {{ scope.row.freeze_amount | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <h2>一般代理數據分析</h2>
    <el-table
      :data="list"
      style="width: 100%;margin-bottom: 20px;"
      :span-method="arraySpanMethod"
      border
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <!-- :show-header="false" -->
          <el-table
            class="table-in-table"
            :data="props.row.children"
            style="width: 100%;"
            row-key="id"
            border
          >
            <el-table-column
              align="center"
              prop="date"
              rowspan="2"
              label="日期"
            >
            </el-table-column>
            <el-table-column align="center" prop="s_today" label="結餘">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.s_today | decimalPoint | thousands }}
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="s_yesterday" label="初始餘額">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.s_yesterday | decimalPoint | thousands }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="c_amount"
              label="代收成功金額"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.c_amount | decimalPoint | thousands }}
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="c_fee" label="代收手續費">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.c_fee | decimalPoint | thousands }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="m_add_amount"
              label="手動增加金額"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.m_add_amount | decimalPoint | thousands }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="m_reduce_amount"
              label="手動減少金額"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.m_reduce_amount | decimalPoint | thousands }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="unfreeze_amount"
              label="解凍金額"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.unfreeze_amount | decimalPoint | thousands }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="freeze_amount"
              label="凍結金額"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.freeze_amount | decimalPoint | thousands }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="id" label="商戶號">
      </el-table-column>
      <el-table-column align="center" prop="user_name" label="用戶名">
      </el-table-column>
      <el-table-column align="center" prop="s_today" label="結餘">
        <template slot-scope="scope">
          <div>
            {{ scope.row.s_today | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="s_yesterday" label="初始餘額">
        <template slot-scope="scope">
          <div>
            {{ scope.row.s_yesterday | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="c_amount" label="代收成功金額">
        <template slot-scope="scope">
          <div>
            {{ scope.row.c_amount | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="c_fee" label="代收手續費">
        <template slot-scope="scope">
          <div>
            {{ scope.row.c_fee | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="m_add_amount" label="手動增加金額">
        <template slot-scope="scope">
          <div>
            {{ scope.row.m_add_amount | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="m_reduce_amount"
        label="手動減少金額"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.m_reduce_amount | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="unfreeze_amount" label="解凍金額">
        <template slot-scope="scope">
          <div>
            {{ scope.row.unfreeze_amount | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="freeze_amount" label="凍結金額">
        <template slot-scope="scope">
          <div>
            {{ scope.row.freeze_amount | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchData: {},
      saveData: false,
      inSearch: false,
      page: 1,
      dataList: [],
      currentDate: [],
      list: []
    };
  },
  watch: {
    page() {
      if (this.inSearch) {
        this.inSearch = false;
        return;
      }
      this.getData();
    }
  },
  methods: {
    arraySpanMethod({ row, columnIndex }) {
      if (!row.children) {
        if (columnIndex === 0) {
          return [0, 0];
        } else if (columnIndex === 1) {
          return [1, 2];
        }
      }
    },
    getData() {
      let searchData = {};
      if (this.saveData) {
        searchData = JSON.parse(JSON.stringify(this.saveData));
      } else {
        searchData = JSON.parse(JSON.stringify(this.searchData));
        if (this.currentDate) {
          searchData.date_start = this.currentDate[0];
          searchData.date_end = this.currentDate[1];
        }
      }
      Object.keys(searchData).forEach(e => {
        if (!searchData[e] && String(searchData[e]) !== "0") {
          delete searchData[e];
        }
      });
      searchData.page = this.page;
      this.$http
        .post(`/back/customers/getMethodDailySummary`, searchData)
        .then(res => {
          if (res.data.code == 0) {
            let list = {};
            let endList = [];
            res.data.data.forEach(e => {
              let dataa = JSON.parse(JSON.stringify(e));
              let have = true;
              if (!list[dataa.user_id]) {
                list[dataa.user_id] = dataa;
                list[dataa.user_id].children = [];
                have = false;
              }
              list[dataa.user_id].children.push(dataa);
              if (have) {
                Object.keys(dataa).forEach(key => {
                  if (
                    key != "id" &&
                    key != "user_id" &&
                    key != "user_name" &&
                    key != "updated_at" &&
                    key != "currency" &&
                    key != "date" &&
                    typeof (dataa[key] * 1) == "number"
                  ) {
                    list[dataa.user_id][key] =
                      list[dataa.user_id][key] * 1 + dataa[key] * 1;
                  }
                });
              }
            });
            Object.keys(list).forEach(e => {
              endList.push(list[e]);
            });
            this.list = endList;
            this.saveData = JSON.parse(JSON.stringify(searchData));
            this.inSearch = false;
            this.pagination = res.data.paginate;
          }
        });
    }
  },
  created() {
    this.getData();
  }
};
</script>
